module.exports = __webpack_public_path__ + "img/arrow-down.79e0d3a8.svg";